import React from 'react'
import { AppSvg, FormattedHTMLMessage, icons } from '@web/walter-ui-kit'
import { HttpError } from '@web/walter-lib/api'
import { capitalize } from 'lodash'
import styles from './style.module.css'
import { globalLang } from '~globalLang'
import { CaptchaErrorCodes } from '~hooks/useCaptcha'

export const processErrorResponse = (error: unknown) => {
    if (error instanceof HttpError) {
        if (error?.response?.data?.api_error?.message) {
            return capitalize(error?.response?.data?.api_error?.message)
        }

        if (error?.response?.data?.error?.description) {
            return capitalize(error?.response?.data?.error?.description)
        }

        if (error?.response?.data?.error?.message) {
            return capitalize(error?.response?.data?.error?.message)
        }

        if (error.message) {
            return capitalize(error.message)
        }
    }
    if (error instanceof Error) {
        if (isCaptchaError(error)) {
            return error.message
        }
    }
    return ''
}

export const processErrorCode = (error: unknown) => {
    if (error instanceof HttpError) {
        if (error?.response?.data?.api_error?.error_code) {
            return error?.response?.data?.api_error?.error_code
        }
    }
    return ''
}

export const getErrorNotification = (error?: unknown) => ({
    intent: 'notification' as const,
    createdAt: Date.now(),
    icon: (
        <span className={styles.error}>
            <AppSvg svgName={icons.ic18CircleCrossedOut} />
        </span>
    ),
    title: (
        <span className={styles.error}>
            <FormattedHTMLMessage {...globalLang.networkError} />
        </span>
    ),
    content: processErrorResponse(error) || <FormattedHTMLMessage {...globalLang.somethingWrong} />,
})

function isCaptchaError(error: Error) {
    const errorCode = (error?.cause as { code?: CaptchaErrorCodes })?.code
    return errorCode === CaptchaErrorCodes.captchaSkip
}
